module.exports = __webpack_public_path__ + "static/media/receive-point.ee72099f.mp3";